module.exports = __webpack_public_path__ + "static/img/H4.17bbdc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cowboy/H4.png
// module id = JVfC
// module chunks = 0